import React, { useMemo } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

const options = {
    responsive: true,
    plugins: {
        legend: {
            display: false,
        },
    },
    circumference: 180,
    rotation: 270,
    cutout: 50,
};

type Props = {
    total: number;
    actioned: number;
    pending: number;
    supplierNegotiation: number;
};

function RequestsInProgressChart({
    total,
    actioned,
    pending,
    supplierNegotiation,
}: Props) {
    const data = useMemo(
        () => ({
            labels: [''],
            datasets: [
                {
                    label: 'Actioned',
                    data: [actioned, total - actioned],
                    backgroundColor: ['#add8e6', '#f0f1f3'],
                },
                {
                    label: 'Pending',
                    data: [pending, total - pending],
                    backgroundColor: ['#ffa500', '#f0f1f3'],
                },
                {
                    label: 'Sup. Negotiation',
                    data: [supplierNegotiation, total - supplierNegotiation],
                    backgroundColor: ['#004d94', '#f0f1f3'],
                },
            ],
        }),
        [actioned, pending, supplierNegotiation, total],
    );

    const hasData = useMemo(() => {
        return total > 0;
    }, [actioned, pending, supplierNegotiation, total]);

    return (
        <div>
            {hasData ? (
                <Doughnut data={data} options={options} />
            ) : (
                <div className="flex justify-center items-center h-96">
                    No requests in progress
                </div>
            )}
        </div>
    );
}

export default RequestsInProgressChart;
